<template>
  <div class="entry">
    <div class="error">
      <div class="error_bg">
        <div class="error_inner">
          <h1 class="error_title">500</h1>
          <h4 class="error_subtitle">{{ $t('title.error') }}</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorPage',
  metaInfo() {
    return {
      title: this.$t('meta.other.titleTmpl', {
        h1: this.$t('title.error'),
      }),
      meta: [
        {
          name: 'robots',
          content: 'noindex, follow',
        },
        {
          name: 'description',
          content: this.$t('meta.other.descriptionTmpl', {
            h1: this.$t('title.error'),
          }),
        },
      ],
    }
  },
  mounted() {
    this.$h.gtmDataLayerPush({
      ecomm_pagetype: 'other',
    })
  },
}
</script>

<style></style>
